import { StrictMode, useEffect } from "react";
import App from "./App";
import { markRenderReady } from "./renderReady";

function RenderReadyReporter() {
  useEffect(() => {
    void markRenderReady();
  }, []);

  return null;
}

export function AppRoot() {
  return (
    <StrictMode>
      <App />
      <RenderReadyReporter />
    </StrictMode>
  );
}
